import React from "react";
import useProductInfo from "../context/ProductInfoProvider";
import {Alert} from "peggirkit";
import {formatMoney} from "@/utils/MoneyUtils";
import {FormattedMessage} from "react-intl";


const ProductDepositIndication = () => {
    const {product} = useProductInfo();

    if (Number(product.deposit) === 0) {
        return <></>;
    }

    return (
        <Alert
            type={"warning"}
            title={
                <FormattedMessage
                    id={"ex-deposit"}
                    values={{
                        price: formatMoney(Number(product.deposit))
                    }}
                />
            }
        />
    );
};

export default ProductDepositIndication;